export default __webpack_public_path__ + "static/media/FrozenABC_02.531423ab.png";